<template>
  <div class="invitePersonPlan">
    <div class="top">
      <el-button type="primary" plain size="small" @click="back">
        返回
      </el-button>
    </div>
    <div class="content clearfix">
      <div class="left">
        <img :src="join1" class="join1" /> <br />
        <img :src="addp" class="addp" /> <br />
        <img :src="join2" class="join2" />
      </div>
      <div class="right">
        <el-form ref="form" :model="form" :inline="true" label-width="120px" size="small">
          <div class="my-table">
            <div class="my-title fl">
              填写手机号码，邀请指定用户加入项目
            </div>
            <div v-for="(item, $index) in form.list" :key="$index" class="clear" style="margin-top:10px;">
              <device-info :index="$index" :device-info="item" :list="form.list" :type="2"
                @removeComponent="removeComponent" @addComponent="addComponent"></device-info>
            </div>
          </div>
        </el-form>
        <div class="submitReportBox">
          <el-button size="small" :loading="lodinging" type="primary" @click="submitReport('form')">
            确认邀请
          </el-button>
        </div>
      </div>
    </div>
    <el-dialog v-if="professionDialogVisible" v-dialogDrag :visible.sync="professionDialogVisible"
      :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handlePofessionClose" title="邀请成功"
      custom-class="profession-dialog" width="500px">
      <span>
        <p class="fontTop">已邀请用户加入项目</p>
        <p>若用户暂未加入企业，则需用户先同意加入企业后才可成功加入项目</p>
        <p>快复制链接邀请用户吧~</p>
        <p style="margin-top:20px">
          <el-button size="small" type="primary" @click="confirmAddSpec">复制邀请链接</el-button>
        </p>
      </span>
    </el-dialog>
    <Vcode :show="isShow" :canvas-width="349" :canvas-height="209" class="vue-puzzle-vcodeone" @success="onSuccess"
      @close="onclose" />
  </div>
</template>

<script>
import deviceInfo from "@/CommonDP/components/invitePeople";
import systemPersonService from "@/CommonDP/service/enterprisePerson-service";
import Vcode from "vue-puzzle-vcode";
import { mapState } from "vuex";
import { baseUrlWeb } from "@/CommonDP/utils";
export default {
  name: "InvitePersonPlan",
  components: { deviceInfo, Vcode },
  data() {
    const telephone1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("手机号格式错误!"));
      } else {
        callback();
      }
    };
    const neiwaibu2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择人员类别"));
      } else {
        callback();
      }
    };
    const specRole2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择所属专业/角色"));
      } else {
        callback();
      }
    };
    return {
      form: {
        list: [
          {
            phone: "",
            neiwaibu: "",
            bumen: "",
            bumenid: "",
            specRole: "",
            rules: {
              telephone: { trigger: "change", validator: telephone1 },
              neiwaibu1: { trigger: "change", validator: neiwaibu2 },
              specRole1: { trigger: "change", validator: specRole2 }
            }
          }
        ]
      },
      form1: {
        list: [
          {
            phone: "",
            neiwaibu: "",
            bumen: "",
            bumenid: "",
            specRole: "",
            rules: {
              telephone: { trigger: "change", validator: telephone1 },
              neiwaibu1: { trigger: "change", validator: neiwaibu2 },
              specRole1: { trigger: "change", validator: specRole2 }
            }
          }
        ]
      },
      lodinging: false,
      professionDialogVisible: false,
      lianjie: "",
      isShow: false, // 验证码模态框是否出现
      datalist: [],
      join1: require("@/CommonDP/assets/addpersonInfo/invitejoin.png"),
      addp: require("@/CommonDP/assets/addpersonInfo/addp.png"),
      join2: require("@/CommonDP/assets/addpersonInfo/协同小助手.png"),
      repeat: "",
      repeat2: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: (state) => state.projectMg.prjObj
    })
  },
  methods: {
    back() {
      this.$router.push({ name: "personPlan" });
    },
    addComponent(index) {
      const ii = index + 1;
      const ll = this.form.list.length;
      if (ll == ii) {
        const telephone1 = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请输入手机号"));
          } else if (!/^1[3-9]\d{9}$/.test(value)) {
            callback(new Error("手机号格式错误!"));
          } else {
            this.repeat = callback;
            this.repeat2 = value;
            this.querymo();
          }
        };
        const neiwaibu2 = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请选择人员类别"));
          } else {
            callback();
          }
        };
        const specRole2 = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请选择所属专业/角色"));
          } else {
            callback();
          }
        };
        this.form.list.push({
          phone: "",
          neiwaibu: "",
          bumen: "",
          bumenid: "",
          specRole: "",
          rules: {
            telephone: { trigger: "change", validator: telephone1 },
            neiwaibu1: { trigger: "change", validator: neiwaibu2 },
            specRole1: { trigger: "change", validator: specRole2 }
          }
        });
      }
    },
    querymo() {
      const encoded = encodeURI(this.repeat2);
      const pilots = this.form.list;
      const rebels = pilots.filter((pilot) => pilot.phone === encoded);
      if (rebels.length >= 2) {
        this.repeat(new Error("手机号不能重复"));
      } else {
        this.repeat();
      }
    },
    removeComponent(index) {
      this.form.list.splice(index, 1);
    },
    submitReport() {
      this.lianjie = "";
      const { prjId } = this.prjInfo;
      const phones = this.form.list.filter((item) => item.phone !== "");
      const neiwaibus = this.form.list.filter((item) => item.neiwaibu !== "");
      const specRole = this.form.list.filter((item) => item.specRole !== "");
      if (phones.length || neiwaibus.length || specRole.length) {
        const data = [];
        this.form.list.forEach((value, key) => {
          if (value.phone) {
            if (!/^1[3-9]\d{9}$/.test(value.phone)) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!value.specRole) {
              this.$refs.form.validateField("list." + key + ".specRole");
            } else if (!value.neiwaibu) {
              this.$refs.form.validateField("list." + key + ".neiwaibu");
            } else {
              const tt = {
                phone: value.phone,
                isExternal: value.neiwaibu,
                deptIds: value.bumenid,
                prjId: prjId,
                specId: value.specRole[0],
                roleId: value.specRole[1]
              };
              data.push(tt);
            }
          } else if (value.specRole) {
            if (!value.phone) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!/^1[3-9]\d{9}$/.test(value.phone)) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!value.neiwaibu) {
              this.$refs.form.validateField("list." + key + ".neiwaibu");
            } else {
              const ttt = {
                phone: value.phone,
                isExternal: value.neiwaibu,
                deptIds: value.bumenid,
                prjId: prjId,
                specId: value.specRole[0],
                roleId: value.specRole[1]
              };
              data.push(ttt);
            }
          } else if (value.neiwaibu) {
            if (!value.phone) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!/^1[3-9]\d{9}$/.test(value.phone)) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!value.specRole) {
              this.$refs.form.validateField("list." + key + ".specRole");
            } else {
              const ttt = {
                phone: value.phone,
                isExternal: value.neiwaibu,
                deptIds: value.bumenid,
                prjId: prjId,
                specId: value.specRole[0],
                roleId: value.specRole[1]
              };
              data.push(ttt);
            }
          }
        });
        console.log(data, "提交");
        if (data.length >= 1) {
          console.log("调添加接口");
          this.isShow = true;
          this.datalist = data;
        }
      } else {
        this.$message({
          duration: 1000,
          message: "最少加一人",
          type: "warning"
        });
      }
    },
    onSuccess() {
      this.isShow = false;
      this.lodinging = true;
      const params = {
        enterpriseId: this.enterpriseId,
        userList: this.datalist
      };
      console.log(this.form, "this.form");
      console.log(params, "params");
      systemPersonService
        .enterpriseGeteInviCode(params)
        .then((res) => {
          if (res.result == "0") {
            this.professionDialogVisible = true;
            this.lianjie = res.data;
            this.lodinging = false;
            this.form = this.form1;
            this.$nextTick(() => {
              this.$refs["form"].resetFields();
            });
          }
        })
        .catch(() => {
          this.lodinging = false;
        });
    },
    D() {
      this.professionDialogVisible = false;
    },
    confirmAddSpec() {
      let code = "";
      code = baseUrlWeb() + "/joinEnterprise?code=" + this.lianjie;
      this.$copyText(code).then((res) => {
        this.professionDialogVisible = false;
        this.$message.success("链接复制成功!");
      });
    },
    qingkong() {
      this.form.list = [];
      const telephone1 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入手机号"));
        } else if (!/^1[3-9]\d{9}$/.test(value)) {
          callback(new Error("手机号格式错误!"));
        } else {
          callback();
        }
      };
      const neiwaibu2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请选择人员类别"));
        } else {
          callback();
        }
      };
      const specRole2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请选择所属专业/角色"));
        } else {
          callback();
        }
      };
      this.form.list.push({
        phone: "",
        neiwaibu: "",
        bumen: "",
        bumenid: "",
        specRole: "",
        rules: {
          telephone: { trigger: "change", validator: telephone1 },
          neiwaibu1: { trigger: "change", validator: neiwaibu2 },
          specRole1: { trigger: "change", validator: specRole2 }
        }
      });
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    },
    onclose() {
      this.isShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.invitePersonPlan {
  height: 100%;
  min-width: 1540px;
  background: #fff;
  .top {
    height: 57px;
    line-height: 57px;
    border-bottom: 1px solid #d3d9e8c4;
    padding-left: 18px;
  }
  .content {
    background: #f4f5fa;
    border-radius: 4px;
    margin-left: 18px;
    margin-right: 18px;
    height: calc(100% - 96px);
    margin-top: 19px;
  }
  .my-table .btn-table {
    left: 28px;
    width: calc(100% - 28px);
  }
  .el-button--small {
    width: auto;
  }
  .my-form .el-input__inner,
  .my-table .el-input__inner {
    width: 160px;
    height: 30px;
    line-height: 30px;
  }
  .detail-info .el-input__inner {
    width: 480px;
  }
  .el-textarea__inner {
    width: 625px;
  }
  .el-form-item__content {
    height: 40px;
  }
  .left {
    float: left;
    .join1 {
      margin-top: 147px;
      margin-left: 198px;
    }
    .addp {
      margin-top: 70px;
      margin-left: 19px;
    }
    .join2 {
      margin-top: 40px;
      margin-left: 198px;
    }
  }
  .right {
    float: left;
    margin-left: 73px;
    width: 930px;
    /deep/ .el-input__inner {
      width: 210px !important;
    }
    /deep/ .el-form-item {
      margin-bottom: 15px;
    }
  }
  .clearfix:after {
    /* 正常浏览器 清除浮动 */
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .clearfix {
    *zoom: 1; /* zoom 1 就是ie6 清除浮动的方法 * 是ie7以下的版本所识别 */
  }
  .my-title {
    font-size: 18px;
    margin-top: 45px;
    margin-bottom: 20px;
  }
  .submitReportBox {
    text-align: right;
    margin-right: 63px;
  }
  /deep/ .profession-dialog {
    border-radius: 5px;
    .el-dialog__body {
      padding: 20px;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
      box-sizing: border-box;
      p {
        text-align: center;
        height: 25px;
        line-height: 25px;
      }
      .fontTop {
        color: var(--theme-color);
        font-size: 15px;
      }
    }
  }
}
</style>
<style>
.vue-puzzle-vcodeone {
  z-index: 9999 !important;
}
</style>
